export var StylesRelativesUnitsEnum;
(function (StylesRelativesUnitsEnum) {
    StylesRelativesUnitsEnum["CH"] = "ch";
    StylesRelativesUnitsEnum["DYNAMIC_VIEWPORT_WIDTH"] = "dvw";
    StylesRelativesUnitsEnum["DYNAMIC_VIEWPORT_HEIGHT"] = "dvh";
    StylesRelativesUnitsEnum["EM"] = "em";
    StylesRelativesUnitsEnum["EX"] = "ex";
    StylesRelativesUnitsEnum["LARGE_VIEWPORT_WIDTH"] = "lvw";
    StylesRelativesUnitsEnum["LARGE_VIEWPORT_HEIGHT"] = "lvh";
    StylesRelativesUnitsEnum["LINE_HEIGHT"] = "lh";
    StylesRelativesUnitsEnum["REM"] = "rem";
    StylesRelativesUnitsEnum["ROOT_LINE_HEIGHT"] = "rlh";
    StylesRelativesUnitsEnum["SMALL_VIEWPORT_WIDTH"] = "svw";
    StylesRelativesUnitsEnum["SMALL_VIEWPORT_HEIGHT"] = "svh";
    StylesRelativesUnitsEnum["VB"] = "vb";
    StylesRelativesUnitsEnum["VI"] = "vi";
    StylesRelativesUnitsEnum["V_MAX"] = "vmax";
    StylesRelativesUnitsEnum["V_MIN"] = "vmin";
    StylesRelativesUnitsEnum["VIEWPORT_WIDTH"] = "vw";
    StylesRelativesUnitsEnum["VIEWPORT_HEIGHT"] = "vh";
})(StylesRelativesUnitsEnum || (StylesRelativesUnitsEnum = {}));
//# sourceMappingURL=styles-relatives-units.enum.js.map